import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { TimeOffService } from 'src/app/pages/timeoff/time-off.service';
import { WebixDatatablecomponent } from './webix-datatable.component';
import { OrderByPipe } from 'src/app/shared/pipe/order-by.pipe';

@Component({
  selector: 'app-view-group-timeoff-modal',
  templateUrl: './view-group-timeoff-modal.component.html',
  styleUrls: ['./view-group-timeoff-modal.component.css']

})
export class ViewGroupTimeoffModalComponent implements OnInit, AfterViewInit {
  @Input() userData: any;
  @ViewChild(WebixDatatablecomponent, { static: false }) grid: WebixDatatablecomponent
  @ViewChild('modalSize', { static: false }) modalSize: ElementRef;
  formData: { [key: string]: any } = {};
  //tempsummaryRows = null;
  monthFormat: string = "MM/yyyy";
  isOpen: any[] = [];
  webixDataList: any[];
  webixGridData: any[];
  portalSettings: any;
  data: any;
  monthOn: boolean;
  newDateArray: any[];
  monthData: any[];
  orderByPipe: any;
  monthChangeTrigger: boolean;
  DateJs = <any>Date;
  datePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean, minMode: string };
  format: string;
  mobileMode: boolean;
  selectedData: any[] = [];
  gridWidth: number = 750;
  isDataSelected: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (((this.monthData.length > 0 && this.formData.selectedMonth != null) || this.formData.selectedMonth == null) && this.webixDataList.length > 0) {
      if (event.target.innerWidth > 992) {
        this.gridWidth = 750;
      } else {
        this.gridWidth = this.modalSize.nativeElement.clientWidth - 32;
      }
      this.grid.reSize();
    }
  }

  constructor(private activeModal: NgbActiveModal, private timeOffService: TimeOffService, portalSettingsService: PortalSettingsService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.mobileMode = this.mobileAndTabletcheck();
    this.format = "MM/YYYY";
    this.datePickerOptions = { dateInputFormat: this.format.toUpperCase(), containerClass: "theme-blue", showTodayButton: true, showClearButton: false, clearPosition: "left", showWeekNumbers: false, minMode: "month" };
    this.orderByPipe = new OrderByPipe();
    this.formData.selectedMonth = new Date(moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).add(1, 'days').format("YYYY-MM-DD"));
    this.monthChange();
  }

  ngAfterViewInit(): void {
    if (window.innerWidth > 992) {
      this.gridWidth = 750;
    } else {
      this.gridWidth = this.modalSize.nativeElement.clientWidth - 32;
    }
  }
  mobileAndTabletcheck() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check;
  }

  webixUpdate() {
    this.webixDataList = [];
    this.webixGridData.forEach((val: any, key: any) => {
      var tf = false;
      if (this.webixDataList.length == 0 && val.SubmittedbyFullName != "Holiday") {
        this.webixDataList.push({ id: key, Employee: val.SubmittedbyFullName, PREHKeyID: val.PREHKeyID });
      }
      this.webixDataList.forEach((val2: any, key2: any) => {
        if (val2.PREHKeyID == val.PREHKeyID) {
          tf = true;
        }
        if (key2 == this.webixDataList.length - 1 && !tf && val.SubmittedbyFullName != "Holiday") {
          this.webixDataList.push({ id: key, Employee: val.SubmittedbyFullName, PREHKeyID: val.PREHKeyID });
        }
      });
    });
    this.webixGridData.forEach(val => {
      this.webixDataList.forEach(val2 => {
        if (val2.PREHKeyID == val.PREHKeyID) {
          if (this.portalSettings["CountryDateCode"].ConfigValue == "US")
            var tempAdd = new Date(parseInt("20" + val.FromDateDisplay.substring(6, 8)), parseInt(val.FromDateDisplay.substring(0, 2)) - 1, val.FromDateDisplay.substring(3, 5));
          else {
            var tempAdd = new Date(parseInt("20" + val.FromDateDisplay.substring(6, 8)), parseInt(val.FromDateDisplay.substring(3, 5)) - 1, val.FromDateDisplay.substring(0, 2));
          }
          val2[tempAdd.getMonth() + 1] = true;
          val2["editor"] = "LeaveCode: " + (val.LeaveDescription == null ? "" : val.LeaveDescription) + " FromDate: " + val.FromDateDisplay + " ToDate: " + val.ToDateDisplay + " Hours: " + val.PlannedHours;
          while (tempAdd <= (this.portalSettings["CountryDateCode"].ConfigValue == "US" ? new Date(parseInt("20" + val.ToDateDisplay.substring(6, 8)), parseInt(val.ToDateDisplay.substring(0, 2)) - 1, val.ToDateDisplay.substring(3, 5)) : new Date(parseInt("20" + val.ToDateDisplay.substring(6, 8)), parseInt(val.ToDateDisplay.substring(3, 5)) - 1, val.ToDateDisplay.substring(0, 2)))) {
            var month = tempAdd.getMonth() + 1;
            var date = tempAdd.getDate().toString().length == 1 ? "0" + tempAdd.getDate() : tempAdd.getDate();
            var year = this.formData.selectedMonth.getFullYear();
            var dateKey = month + "/" + date + "/" + year;
            if (!val2.hasOwnProperty(dateKey) ||
              (val2.hasOwnProperty(dateKey) &&
                ((val2[dateKey].substring(0, 1) != "A" && val.RequestStatus == "Approved") ||
                  (val2[dateKey].substring(0, 1) == "R" && val.RequestStatus == "Pending")))) {
              val2[dateKey] =
                (val.RequestStatus == "H" ? "H<a style='background-color:#00c4ff;color:white;font-size: 28px;margin-left:-24px;padding: 7px;' href='javascript:void(0)' class='load'><i class='modus-icons'>car_front</i></a>" :
                  val.RequestStatus == "Approved" ? (val.PlannedHours >= val.DefaultWorkHours ? "A<a style='background-color:#5cb85c;color:white;font-size: 27px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>circle_check_outline</i></a>" : "A<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/approvedHalf.png'/></a>") :
                    val.RequestStatus == "Rejected" ? (val.PlannedHours >= val.DefaultWorkHours ? "R<a style='background-color:red;color:white;font-size: 26px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>circle_close</i></a>" : "R<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/rejectedHalf.png'/></a>") :
                      val.RequestStatus == "Pending" ? (val.PlannedHours >= val.DefaultWorkHours ? "P<a style='background-color:#ECC816;color:white;font-size: 29px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>help</i></a>" : "P<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/pendingHalf.png'/></a>") :
                        (tempAdd.getDay() != 0 && tempAdd.getDay() != 6 ? "C<a style='background-color:white;color:white;font-size:20px;margin-left:-24px;padding:20px;'></a>" : "C<a style='background-color:rgb(204, 204, 204);color:rgb(204, 204, 204);font-size:20px;margin-left:-24px;padding:20px;'></a>")) +
                "|LeaveCode|" + (val.LeaveDescription == null ? "" : val.LeaveDescription) + "|FromDate|" + val.FromDateDisplay + "|ToDate|" + val.ToDateDisplay + "|Hours|" + val.PlannedHours + "|DefaultWorkHours|" + val.DefaultWorkHours +
                "|Name|" + val.SubmittedbyFullName + "|Status|" + val.RequestStatus + "|Note|" + val.ApprovalString;
              tempAdd = tempAdd.add(1).day();
            } else {
              if (val2[dateKey].substring(0, 1) == "C" && val2[dateKey].substring(0, 1) != "H") {
                val2[dateKey] =
                  (val.RequestStatus == "H" ? "H<a style='background-color:#00c4ff;color:white;font-size: 28px;margin-left:-24px;padding: 7px;' href='javascript:void(0)' class='load'><i class='modus-icons'>car_front</i></a>" :
                    val.RequestStatus == "Approved" ? (val.PlannedHours >= val.DefaultWorkHours ? "A<a style='background-color:#5cb85c;color:white;font-size: 27px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>circle_check_outline</i></a>" : "A<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/approvedHalf.png'/></a>") :
                      val.RequestStatus == "Rejected" ? (val.PlannedHours >= val.DefaultWorkHours ? "R<a style='background-color:red;color:white;font-size: 26px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>circle_close</i></a>" : "R<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/rejectedHalf.png'/></a>") :
                        val.RequestStatus == "Pending" ? (val.PlannedHours >= val.DefaultWorkHours ? "P<a style='background-color:#ECC816;color:white;font-size: 29px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>help</i></a>" : "P<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/pendingHalf.png'/></a>") :
                          (tempAdd.getDay() != 0 && tempAdd.getDay() != 6 ? "C<a style='background-color:white;color:white;font-size:20px;margin-left:-24px;padding:20px;'></a>" : "C<a style='background-color:rgb(204, 204, 204);color:rgb(204, 204, 204);font-size:20px;margin-left:-24px;padding:20px;'></a>")) +
                  "|LeaveCode|" + (val.LeaveDescription == null ? "" : val.LeaveDescription) + "|FromDate|" + val.FromDateDisplay + "|ToDate|" + val.ToDateDisplay + "|Hours|" + val.PlannedHours + "|DefaultWorkHours|" + val.DefaultWorkHours +
                  "|Name|" + val.SubmittedbyFullName + "|Status|" + val.RequestStatus + "|Note|" + val.ApprovalString;
              }

              tempAdd = tempAdd.add(1).day();
            }
          }
        }
      });
    });
    var tempFoYr = this.formData.selectedMonth.getFullYear();
    var tempFoMth = this.formData.selectedMonth.getMonth();
    var tempToYr = this.formData.selectedMonth.getFullYear();
    var tempToMth = this.formData.selectedMonth.getMonth() + 1;
    if (tempToMth == 12) {
      tempToYr++;
      tempToMth = 0;
    }
    var tempAdd = new Date(tempFoYr, tempFoMth, 1);
    while (tempAdd <= new Date(tempToYr, tempToMth, 1)) {
      var month = tempAdd.getMonth() + 1;
      var date = tempAdd.getDate().toString().length == 1 ? "0" + tempAdd.getDate() : tempAdd.getDate();
      var year = tempAdd.getFullYear();
      this.webixDataList.forEach(val => {
        if (!val.hasOwnProperty((month + "/" + date + "/" + year))) {
          if (tempAdd.getDay() == 6 || tempAdd.getDay() == 0) {
            val[month + "/" + date + "/" + year] = "<a style='background-color:rgb(204, 204, 204);color:rgb(204, 204, 204);font-size:20px;margin-left:-16px;padding:20px;'></a>";
          }
        }
      });
      tempAdd = tempAdd.add(1).day();
    }
  }

  getNewDates(startDate: any, stopDate: number | Date) {
    var dateArray = new Array();
    dateArray.push({ id: "Employee", header: { text: "Employee", rotate: false, height: 60 }, width: 150, sort: "string" });
    var currentDate = startDate;
    while (currentDate < stopDate) {
      var month = currentDate.getMonth() + 1;
      var date = currentDate.getDate().toString().length == 1 ? "0" + currentDate.getDate() : currentDate.getDate();
      var year = currentDate.getFullYear();
      dateArray.push({ id: month + "/" + date + "/" + year, header: { text: ((this.portalSettings.CountryDateCode.ConfigValue == "US") ? (month + "/" + date) : (date + "/" + month)), rotate: true, css: "myClass" }, width: 30 });
      currentDate = currentDate.add(1).day();
    }
    return dateArray;
  }

  monthChange() {
    this.data = null;
    if (this.formData.selectedMonth != null) {
      if (this.formData.selectedMonth.getDate() > 1) {
        this.formData.selectedMonth = new Date(this.formData.selectedMonth.getFullYear(), this.formData.selectedMonth.getMonth(), 1);
      }
    }
    var tempselectedDate = new Date(this.formData.selectedMonth.getTime());
    this.monthOn = true;
    this.newDateArray = [];
    this.newDateArray = this.getNewDates(new Date(tempselectedDate.setHours(0, 0, 0, 0)), tempselectedDate.add(1).month());
    this.monthData = [];
    if (this.formData.selectedMonth != null) {
      this.timeOffService.getRequestsByMonth(this.userData.PRCo, moment(this.formData.selectedMonth).format("YYYY-MM-DD"), this.userData.UserKeyID).then((response: any[]) => {
        this.webixGridData = this.orderByPipe.transform(response, "SubmittedbyFullName", "asc");
        this.webixUpdate();
        this.monthData = this.webixDataList;
      });
    }
    this.monthChangeTrigger = false;
  }

  open($event, item) {
    this.isOpen = [];
    $event.preventDefault();
    $event.stopPropagation();
    this.isOpen[item] = true;
  }

  updateData(event: any) {
    this.data = event;
  }

  closeClicked() {
    this.activeModal.close();
  };

}